import * as React from 'react';
import { SelectItem, SelectType } from '../types';
import { SelectOptions } from '../select-options';
import { OptionsPaginator } from 'ui/common/select/options-paginator';
import { useCallback } from 'react';
import { CategoryOptionsItem } from './category-options-item';
import { LoadOptions } from 'ui';
import styles from './category-options.scss';

export interface CategoryOptionsProps {
  categoryOptions?: SelectItem[];
  valueItems: SelectItem[];
  showIcons: boolean;
  selectType?: SelectType;
  showLongDescription?: boolean;
  showBackgroundColour?: boolean;
  breadcrumb: React.ReactNode;
  textPageOf?: string;
  minLevel?: number;
  returnedCategoryOptions: SelectItem[];
  includeDisabledCheckbox?: JSX.Element;
  notFoundText: string;
  setCategoryId: (categoryId: number) => void;
  onLoadCategoryOptions: (loadOptions: LoadOptions) => void;
}

export const CategoryOptions = ({
  returnedCategoryOptions,
  valueItems,
  showIcons,
  selectType = SelectType.single,
  showLongDescription = false,
  showBackgroundColour,
  breadcrumb,
  textPageOf = '',
  includeDisabledCheckbox,
  notFoundText,
  setCategoryId,
  onLoadCategoryOptions
}: CategoryOptionsProps) => {

  const selectedValues = valueItems.map(i => i.value);

  const onExpand = useCallback((item: SelectItem) => {
    const itemValue = Number(item.value);
    const hasChildren = item?.descendants?.length > 0;

    if (hasChildren) {
      onLoadCategoryOptions({
        parentId: itemValue
      });
    } else {
      setCategoryId(itemValue);
    }
  }, [setCategoryId]);

  return (
    <>
      {breadcrumb}
      {!!includeDisabledCheckbox
        && <div className="row">
          <div className="col-12 text-end">
            {includeDisabledCheckbox}
          </div>
        </div>}
      <OptionsPaginator options={returnedCategoryOptions} textPageOf={textPageOf} selectedValues={selectedValues}>
        {currentOptions =>
          <SelectOptions showLongDescriptions={showLongDescription}>
            {currentOptions?.map(item =>
              <CategoryOptionsItem
                key={item.value}
                item={item}
                showLongDescription={showLongDescription}
                selectType={selectType}
                showIcons={showIcons}
                showBackgroundColour={showBackgroundColour}
                onExpand={onExpand}
              />
            )}
          </SelectOptions>
        }
      </OptionsPaginator>
      {returnedCategoryOptions?.length === 0
        && <div className={styles.optionsMessage}>{notFoundText}</div>}
    </>
  );
};
